/* KH Jeweler theme.js
   - Mobile nav toggle
   - Smooth fade-in on scroll
   - Subtle hero parallax
   - Native lazy-loading fallback
*/
(function () {
  'use strict';

  // Mark JS available (replace .no-js)
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // -------- Mobile nav --------
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('hidden') === false;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var iconMenu = toggle.querySelector('[data-icon-menu]');
      var iconClose = toggle.querySelector('[data-icon-close]');
      if (iconMenu && iconClose) {
        iconMenu.classList.toggle('hidden', open);
        iconClose.classList.toggle('hidden', !open);
      }
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // -------- Fade-in on scroll --------
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.fade-in').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.fade-in').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // -------- Hero parallax (subtle) --------
  var parallax = document.querySelector('[data-parallax]');
  if (parallax && window.matchMedia('(min-width: 768px)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var y = window.pageYOffset;
          parallax.style.transform = 'translate3d(0,' + (y * 0.18) + 'px,0)';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // -------- Smooth scroll for in-page anchors --------
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var hash = a.getAttribute('href');
    if (hash.length < 2) return;
    var target = document.querySelector(hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', hash);
    }
  });

  // -------- Lazy-load fallback --------
  if (!('loading' in HTMLImageElement.prototype) && 'IntersectionObserver' in window) {
    var imgIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; }
          imgIo.unobserve(img);
        }
      });
    });
    document.querySelectorAll('img[loading="lazy"][data-src]').forEach(function (img) { imgIo.observe(img); });
  }
})();
